<template>
  <div>

    <section class="cart-section" style="padding:30px 0px;">
      <div class="container">
        <div class="">
          <div class="container padding-cls" style="margin-bottom:0px">
            <div class="checkout-page">
              <div class="checkout-form theme-form">
                <div class="row center-content">

                  <!--unit selection -->
                  <div class="row">
                    <div class="col-md-8">
                      <div class="field-label" style="line-height:24px;margin-bottom:10px;padding-left: 5px;">Applied Unit/Subunit</div>
                        <div class="unit-selection-grid">
                            <div
                              v-for="application in applications"
    :key="application.id"
    v-if="application.status == 'paid'"
    class="unit-card"
    :class="{
                            'unit-card-selected': unit === application.unit,
                            'unit-card-eligible': true
                          }"
                          @click="selectUnit(application.unit)"
                        >
                          
                          <input
                            class="unit-radio-hidden"
                            v-model="unit"
                            type="radio"
                            name="unit"
                            :id="'unit' + application.unit"
                            :value="application.unit"
                            @change="getQuotaValues"
                          >

                          <div class="unit-card-content">
                            <div class="unit-check-indicator">
                              <i v-if="unit === application.unit" class="fa fa-check-circle"></i>
                              <i v-else class="fa fa-circle-o"></i>
                            </div>

                            <div class="unit-label">
                              {{ application.unit }}
                            </div>
                          </div>

                        </div>
                      </div>


                    </div>
                    <div class="col-md-4 middle-center" v-if="onSubjectLoading" style="padding-top: 10px;">
                      <global-spinner :animation-duration="1500" :size="50" color="#2196f3" />
                    </div>
                    <div v-if="!save_choice && !onSubjectLoading" class="col-md-3" style="padding-top: 20px;">
                      <!--  <a class="btn light-btn btn-success radius-1" target="_blank" style="margin:4px;float:right"  @click="printSubjectCard">
                        <i aria-hidden="true" class="fa fa-print"></i>
                      </a> -->

                      <button class="btn info-btn btn-info radius-1 d-flex flex-column align-items-center p-2"
                        @click="downloadSubjectChoice" :disabled="isDownloadingSubjectChoice" type="button"
                        style="min-width: 120px;">
                        <!-- Icon always visible, changes to spinner when downloading -->
                        <i :class="isDownloadingSubjectChoice ? 'fa fa-spinner fa-spin' : 'fa fa-download'"
                          aria-hidden="true" style="font-size: 1.2em;"></i>

                        <!-- Message below icon -->
                        <span class="mt-1 text-center" style="font-size: 0.85rem;">
                          {{ isDownloadingSubjectChoice ? subjectChoiceProgress : 'Download Subject Choice PDF' }}
                        </span>
                      </button>





                    </div>




                  </div>

                  <!--quota selection -->
                  <div v-if="unit" class="row">
                    <div class="col-md-12">
                      <div class="field-label" style="line-height:24px;padding-left: 5px;">Quota: </div>
                      <div class="form-check form-check-inline">
                      <!-- <div class="form-check form-check-inline" v-for="tquota in quotas" :key="tquota"> -->
                        <!-- <input class="form-check-input" v-model="quota" style="margin-top:.25em" type="radio"
                          name="quota" :id="'quota' + tquota" :value="tquota" @change="getSubjectList">
                        <label class="form-check-label" :for="'quota' + tquota">{{ tquota }}</label> -->

                        <div class="quota-selection-grid">
                            <div
                              class="unit-card"
                              v-for="tquota in quotas"
                              :key="tquota"
                              :class="{ 'unit-card-selected': quota === tquota }"
                              @click="quota = tquota; getSubjectList()"
                            >
                              <input
                                class="unit-radio-hidden"
                                v-model="quota"
                                type="radio"
                                name="quota"
                                :id="'quota' + tquota"
                                :value="tquota"
                              >

                              <div class="unit-card-content">
                                <div class="unit-check-indicator">
                                  <i v-if="quota === tquota" class="fa fa-check-circle"></i>
                                  <i v-else class="fa fa-circle-o"></i>
                                </div>

                                <div class="unit-label">{{ tquota }}</div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>

                  <!-- assigned subject -->
                  <div v-if="unit && quota && subject_code"
                    class="row text-center alert alert-outline alert-success px-3 p-1 my-2">
                    <span class="">Assigned : <strong>{{ subject_code }}</strong> ({{ subject_name }})</span>
                  </div>
                  <!-- error message -->
                  <div v-else-if="unit && quota && message"
                    class="row text-center alert alert-outline alert-danger text-danger p-1 my-2">
                    <span style="margin-left: 20px; text-transform: uppercase;">{{ message }}</span>
                  </div>

                  <!-- subject selection -->
                  <div v-if="unit && quota" class="">
                    <div class="row">
                      <div class="col-md-5" style="min-height:200px; padding-top: 5px;">
                        <h6 class="text-center" style="margin-bottom:10px">Available Subjects</h6>
                        <draggable v-if="save_choice && !close_choice" class="list-group" :list="subjects"
                          group="people" style="border:1px solid darkgray;">
                          <transition-group>
                            <div class="list-group-item" v-for="(subject, index) in subjects" :key="subject"
                              style="cursor: grab;" v-on:click="move2Selected(index, subject)">{{ subject }}</div>
                          </transition-group>
                        </draggable>
                        <draggable v-else class="list-group" :list="subjects" group="people"
                          style="border:1px solid darkgray;" @start="drag = false" @end="drag = false">
                          <div class="list-group-item" v-for="(subject, index) in subjects" :key="subject"
                            style="cursor: default;">{{ subject }}</div>
                        </draggable>
                      </div>
                      <div class="col-md-1" style="margin:auto; background-colorx: lightgray;">
                        <p>&nbsp;
                          <!--i class="fa fa-arrow-left" aria-hidden="true"></i><br-->
                          <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </p>
                      </div>
                      <div class="col-md-6" style="min-height:200px; padding-top: 5px;">
                        <h6 class="text-center" style="margin-bottom:10px">Selected Subjects</h6>
                        <draggable v-if="save_choice && !close_choice" class="list-group" :list="selectedSubjects"
                          group="people" style="border:1px solid darkgray;">
                          <transition-group>
                            <div class="list-group-item" v-for="(selectedSubject, index) in selectedSubjects"
                              :key="selectedSubject" style="cursor: grab;"
                              v-on:click="move2Available(index, selectedSubject)">{{ selectedSubject }}</div>
                          </transition-group>
                        </draggable>
                        <draggable v-else class="list-group" :list="selectedSubjects" group="people"
                          style="border:1px solid darkgray;" @start="drag = false" @end="drag = false">
                          <div class="list-group-item" v-for="(selectedSubject, index) in selectedSubjects"
                            :key="selectedSubject" style="cursor: default;">{{ selectedSubject }}</div>
                        </draggable>
                      </div>
                    </div>
                    <div v-if="save_choice && !close_choice" class="row" style="margin:20px;text-align:center">
                      <button class="btn info-btn btn-info radius-1" @click="submit" type="button">
                        Submit
                      </button>
                    </div>
                    <div v-if="!save_choice" class="row" style="margin:20px;text-align:center">
                      <div class="btn info-btn btn-info radius-1">{{ message }}</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Loader from '../Helper/Loader'
import { CLAIM_STUDENT_REQUEST, GET_SUBJECT_CHOICE, UPDATE_SUBJECT_CHOICE } from '../../const/api'
import { GET, POST } from '../../utils/Request'
import SubjectChoiceGenerator from '@/utils/SubjectChoiceGenerator'
import '../../assets/css/new-unit-radio-grid.css'

export default {
  name: 'ProfileSubjectSelection',
  props: ['applications'],
  components: { Loader, draggable },
  data() {
    return {
      onSubjectLoading: false,
      units: [],
      quotas: [],
      unit: '',
      quota: '',
      roll: '',
      app_id: '',
      message: '',
      subjects: [],
      selectedSubjects: [],
      subject_code: false,
      subject_name: false,
      save_choice: true,
      close_choice: false,
      isDownloadingSubjectChoice: false,
      subjectChoiceProgress: 'Preparing...'
    }
  },
  created() {
    for (let i = 0; i < this.applications.length; ++i) {
      if (this.applications[i].status == 'paid') {
        this.units.push(this.applications[i].unit);
      }
    }
    /*this.unit = this.units[0];*/
    /*this.getUnitValues();*/
  },

  methods: {
    selectUnit(value) {
      this.unit = value;
      this.getQuotaValues(); // 🔥 force trigger
    },

    async downloadSubjectChoice() {
      if (this.isDownloadingSubjectChoice) {
        return
      }

      this.isDownloadingSubjectChoice = true
      this.subjectChoiceProgress = 'Preparing...'

      try {
        await SubjectChoiceGenerator.generateSubjectChoice(
          this.unit,
          this.quota,
          (message, progress) => {
            this.subjectChoiceProgress = message
          },
          (error) => {
            console.error('Subject Choice generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate subject choice. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Subject Choice downloaded successfully!'
        })
      } catch (error) {
        console.error('Subject Choice download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download subject choice. Please try again.'
        })
      } finally {
        this.isDownloadingSubjectChoice = false
        this.subjectChoiceProgress = 'Preparing...'
      }
    },

    async getQuotaValues() {

      this.quota = '';
      this.message = '';
      this.save_choice = true;

      this.onSubjectLoading = true;

      if (0 && this.firstTimeLoad) {
        if (this.units.length > 0)
          this.unit = this.units[0];
      }

      var data = await GET(GET_SUBJECT_CHOICE + this.unit);
      this.quotas = data.data.quotas;

      this.onSubjectLoading = false;
      this.firstTimeLoad = false;

      /*this.quota = 'GENERAL';*/
      /*this.getSubjectList();*/
    },

    async getSubjectList() {

      this.onSubjectLoading = true;

      if (0 && this.firstTimeLoad) {
        if (this.quotas.length > 0)
          this.quota = this.quotas[0];
      }

      var data = await GET(GET_SUBJECT_CHOICE + this.unit + '/' + this.quota);

      if (data.data.status == 'success') {
        // console.log(data.data);

        this.roll = data.data.exam_roll;
        this.app_id = data.data.application_id;
        this.subjects = data.data.subjects;
        this.selectedSubjects = data.data.selected_subjects;
        this.subject_code = data.data.subject_code;
        this.subject_name = data.data.subject_name;
        this.save_choice = data.data.save_choice;
        this.close_choice = data.data.close_choice;

        if (this.save_choice && !this.close_choice)
          this.message = "You may 'Drag & Drop' or 'Click' on subject on LEFT side to SELECT";
        else
          this.message = data.data.message;
      }
      else {
        this.subjects = [];
        this.selectedSubjects = [];
        this.subject_code = false;
        this.subject_name = false;

        this.message = data.data.message;
      }

      this.onSubjectLoading = false;
      this.firstTimeLoad = false;
    },

    printSubjectCard() {
      window.open('/subjects/' + this.unit + '/' + this.quota, '_blank');
    },

    add: function () {
      this.list.push("Juan");
    },
    replace: function () {
      this.list = ["Edgard"];
    },
    clone: function (el) {
      return {
        name: el + " cloned"
      };
    },
    log: function (evt) {
      /*window.console.log(evt);*/
    },

    move2Selected(idx, subj) {
      this.subjects.splice(idx, 1);
      this.selectedSubjects.push(subj);
    },

    move2Available(idx, subj) {
      this.selectedSubjects.splice(idx, 1);
      this.subjects.push(subj);
    },

    async submit() {

      this.onSubjectLoading = true;

      let response = await POST(UPDATE_SUBJECT_CHOICE, { unit: this.unit, quota: this.quota, subjects: this.selectedSubjects });

      if (response.data.status == 'success') {
        this.message = response.data.message;
        this.save_choice = response.data.save_choice;
      } else {
        this.message = response.data.message;
      }
      this.onSubjectLoading = false;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* Container: Flexbox with wrapping and centered last row */
.unit-selection-grid, .quota-selection-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 15px;           /* spacing between cards */
  padding: 5px 5px;
  justify-content: flex-start;  /* center all rows including last row */
  overflow: visible;        /* ensure hover shadows are visible */
}

/* Unit Card Styling - Fixed size */
.unit-card {
  position: relative;
  z-index: 1;                 /* ensure hover shadows appear above others */
  background: #ffffff;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  min-height: 80px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 120px;    /* FIXED width */
  flex: 0 0 auto;  /* prevent stretching */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

/* Hover Effect */
.unit-card:hover {
  transform: translateY(-3px) translateZ(0); /* ensure smooth hover */
  box-shadow: 0 8px 16px rgba(99, 102, 241, 0.15);
  border-color: #a5b4fc;
}

/* Eligible Unit */
.unit-card-eligible {
  border-color: #e0e7ff;
  background: linear-gradient(135deg, #ffffff 0%, #f8faff 100%);
}

.unit-card-eligible:hover {
  border-color: #818cf8;
}

/* Selected Unit */
.unit-card-selected {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border-color: #4f46e5;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
}

.unit-card-selected:hover {
  transform: translateY(-3px) translateZ(0);
  box-shadow: 0 12px 24px rgba(99, 102, 241, 0.5);
}

.unit-card-selected .unit-label {
  color: #ffffff;
  font-weight: 700;
}

.unit-card-selected .unit-check-indicator i {
  color: #ffffff;
}

/* Ineligible Unit */
.unit-card-ineligible {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fecaca;
  opacity: 0.75;
  cursor: not-allowed;
}

.unit-card-ineligible:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-color: #fecaca;
}

.unit-card-ineligible .unit-label {
  color: #991b1b;
}

/* Hide the actual radio input */
.unit-radio-hidden {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Unit Card Content */
.unit-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  width: 100%;
}

/* Check Indicator */
.unit-check-indicator {
  font-size: 24px;
  margin-bottom: 5px;
}

.unit-check-indicator i {
  color: #6366f1;
  transition: all 0.3s ease;
}

.unit-card:hover .unit-check-indicator i {
  transform: scale(1.1);
}

/* Unit Label */
.unit-label {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

/* Status Badge for Ineligible Units */
.unit-status-badge {
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  background: #ffffff;
  padding: 4px 10px;
  border-radius: 12px;
  margin-top: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.15);
}

.unit-status-badge i {
  font-size: 12px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .unit-card {
    width: 100px;
    min-height: 100px;
  }
}

@media (max-width: 480px) {
  .unit-card {
    width: 90px;
    min-height: 90px;
    padding: 12px 10px;
  }

  .unit-label {
    font-size: 16px;
  }

  .unit-check-indicator {
    font-size: 20px;
  }
}

/* Input fix */
.theme-form input[type="text"] {
  min-width: 100% !important;
}

.loader {
  margin-top: 20%;
}

.d-flex {
  padding: 10px;
  margin: 10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
  box-shadow: 1px 0 15px 2px #c1b3b3;
}

.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid {
  max-width: 100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
  box-sizing: border-box;
}

.flower-spinner {
  margin: auto;
}
</style>